<script setup>
import { defineProps } from 'vue'
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import dayjs from "dayjs";

var relativeTime = require("dayjs/plugin/relativeTime");
dayjs.extend(relativeTime);
dayjs.extend(LocalizedFormat)

const props = defineProps({
  data: { type: [null, String], required: true },
})
</script>
<template>
  <div class="relative group inline-block">
    <span class="cursor-pointer">
      {{ dayjs(data).fromNow() }}
    </span>

    <div
      class="absolute top-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:flex px-2 py-1 text-xs rounded shadow z-50 whitespace-nowrap opacity-0 group-hover:opacity-100
             bg-slate-900 text-white border border-slate-800
             dark:bg-slate-100 dark:text-slate-900 dark:border-slate-200"
    >
      {{ dayjs(data).format('LLL') }}
    </div>
  </div>
</template>
